/**
 * Show global loading bar
 * @returns {Function}
 */
export const instanceConfigured = (instance) => ({
    type: 'INSTANCE_CONFIGURED',
    instance: {
        data: instance,
        error: null
    }
});

/**
 * Hide global loading bar
 * @returns {Function}
 */
/**
 * @param {object} e
 * @param {string} [e.humanError]
 * @param {string} [e.devError]
 * @param {'maintenance'|'network'|'unknown'} [e.kind]  qué pantalla mostrar
 * @param {string|null} [e.clubName]  nombre del gimnasio si la API lo devolvió
 * @param {string|null} [e.clubPhone] teléfono del gimnasio si la API lo devolvió
 */
export const instanceError = ({ humanError = "", devError = "", kind = 'unknown', clubName = null, clubPhone = null } = {}) => ({
    type: 'INSTANCE_ERROR',
    instance: {
        data: null,
        error: {
            humanError,
            devError,
            kind,
            clubName,
            clubPhone
        }
    }
});

/**
 * Muestra la pantalla de mudanza y guarda la URL del ingreso nuevo.
 * @param {string} joinUrl
 */
export const instanceMaintenanceRedirect = (joinUrl) => ({
    type: 'INSTANCE_MAINTENANCE_REDIRECT',
    instance: {
        data: null,
        error: null,
        maintenanceRedirectUrl: joinUrl
    }
});
